import { Image } from '@idaho-aeyc/ui-kit';
import { styled } from 'styled-components';

export const SImage = styled(Image)``;
